import { axios } from '../configs';
import type { TRichMessageTemplate } from 'types/richMessage';

export type TRichMessageTemplatesMeta = {
  baseWidth: number;
  customMinHeight: number;
  customMaxHeight: number;
};

export type TRichMessageTemplatesResponse = {
  templates: TRichMessageTemplate[];
  meta: TRichMessageTemplatesMeta;
};

export const getRichMessageTemplates =
  async (): Promise<TRichMessageTemplatesResponse> => {
    const response = await axios.get<TRichMessageTemplatesResponse>(
      'rich-message/templates',
    );
    return response.data;
  };
